// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2h5qi","signatureBlock":"Footer_signatureBlock__D-b16","signature":"Footer_signature__1_P5G"};